import { InvestRateType } from '@enums/invest-rate-type.enum';

export class InvestProjectRate {
    type: InvestRateType;
    value: number;

    constructor() {
        this.type = InvestRateType.custom;
        this.value = null;
    }
}
